/* @flow */

import * as React from 'react';

type Props = {
  children: React.Node,
  hasCloseButton: boolean,
  title?: React.Node,
  subtitle?: React.Node,
};

const CloseButton = () => (
  <button
    type="button"
    className="procCloseButton proc-button white-bg-color gray10-border-color"
    onClick={() => {
      window.open('about:blank', '_self').close();
    }}
  >
    <div className={'proc-button-inner'}>閉じる</div>
  </button>
);

const InformationPage = ({ children, title, subtitle, hasCloseButton = true }: Props) => (
  <div className="procInformation ">
    <div className="flex flex-column">
      <header className="procHeader procContainer">
        <div alt="proc" className="procHeader-logo" />
      </header>
      <div className="procBody">
        <div className="procContainer flex1 flex flex-column">
          {title && <h2 className="procBody-title">{title}</h2>}
          {subtitle && <small className="procBody-subtitle">{subtitle}</small>}
          <div className="procPanel flex1">{children}</div>
          {hasCloseButton && <CloseButton />}
        </div>
      </div>
      <footer className="procFooter">© 2019 Sony Global Education, Inc.</footer>
    </div>
  </div>
);

export default InformationPage;
